import { abort, audit, batchimport, batchModifyrealqty, generate, get, getByNumber, getByPsTaskUuid, getSchedule, modify, query, queryPickingTasks, querySowingTasks, sowRestStockShift } from '@/services/forward/out/PickTask';
import { formatMessage } from 'umi/locale';
export default {
  namespace: 'pickTask',
  subscriptions: {
    /**
     * 监听浏览器地址，当跳转到 /user 时进入该方法
     * @param dispatch 触发器，用于触发 effects 中的 query 方法
     * @param history 浏览器历史记录，主要用到它的 location 属性以获取地址栏地址
     */
    setup({ dispatch, history }) {
      history.listen((location) => {
        if (location.payload && location.pathname == "/out/pickTask") {
          dispatch({
            type: 'showPage',
            payload: location.payload,
          })
        }
      });
    },
  },
  state: {
    data: {
      list: [],
      pagination: {}
    },
    entity: {},
    showPage: 'query',
    importType: 'PICKTASK',
    cacheData: {
      data: [],
      pageFilter: {}
    },
    adjData: []
  },

  effects: {
    *query({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (response && response.success && response.data) {
        yield put({
          type: 'save',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
      if (callback) callback(response);
    },
    *get({ payload }, { call, put }) {
      const response = yield call(get, payload);
      if (response && response.success) {
        yield put({
          type: 'onView',
          entity: response.data
        });
      }
    },
    *getByNumber({ payload, callback }, { call, put }) {
      const response = yield call(getByNumber, payload);
      if (response && response.success) {
        yield put({
          type: 'onView',
          entity: response.data
        });
      }
      if (callback) callback(response);
    },
    *abort({ payload, callback }, { call, put }) {
      const response = yield call(abort, payload);
      if (callback) callback(response);
    },
    *sowRestStockShift({ payload, callback }, { call, put }) {
      const response = yield call(sowRestStockShift, payload);
      if (callback) callback(response);
    },
    *audit({ payload, callback }, { call, put }) {
      const response = yield call(audit, payload);
      if (response && response.success) {
        yield put({
          type: 'onShowPage',
          showPage: 'view',
          entityUuid: payload.uuid
        });
      }
      if (callback) callback(response);
    },
    *batchAudit({ payload, callback }, { call, put }) {
      const response = yield call(audit, payload);
      if (callback) callback(response);
    },
    *generate({ payload, callback }, { call, put }) {
      const response = yield call(generate, payload);
      if (callback) callback(response);
    },
    *getSchedule({ payload, callback }, { call, put }) {
      const response = yield call(getSchedule, payload);
      if (callback) callback(response);
    },
    *queryPickingTasks({ payload, callback }, { call, put }) {
      const response = yield call(queryPickingTasks, payload);
      if (response && response.success && response.data) {

        yield put({
          type: 'savePickingTasks',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
      if (callback) callback(response);
    },
    *querySowingTasks({ payload, callback }, { call, put }) {
      const response = yield call(querySowingTasks, payload);
      if (response && response.success && response.data) {
        yield put({
          type: 'saveSowingTasks',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
      if (callback) callback(response);
    },
    *getByPsTaskUuid({ payload, callback }, { call, put }) {
      const response = yield call(getByPsTaskUuid, payload);
      if (response && response.success) {
        yield put({
          type: 'saveTaskItems',
          payload: response.data
        });
      }
      if (callback) callback(response);
    },
    *showPage({ payload }, { call, put }) {
      yield put({
        type: 'onShowPage',
        showPage: payload.showPage,
        entityUuid: payload.entityUuid,
        taskNumber: payload.taskNumber,
        importType: payload.importType,
        importData: payload.importData,
        cacheData: payload.cacheData,
        adjData: payload.adjData,
      });
    },
    *queryWavePickTask({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (response && response.success && response.data) {
        yield put({
          type: 'savePickTask',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
      if (callback) callback(response);
    },
    *modify({ payload, callback }, { call, put }) {
      const response = yield call(modify, payload);
      if (callback) callback(response);
    },
    *batchModifyrealqty({ payload, callback }, { call, put }) {
      const response = yield call(batchModifyrealqty, payload);
      if (callback) callback(response);
    },
    *batchimport({ payload, callback }, { call, put }) {
      const response = yield call(batchimport, payload);
      if (callback) callback(response);
    }
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
    savePickingTasks(state, action) {
      return {
        ...state,
        pickingTasks: action.payload,
      };
    },
    saveSowingTasks(state, action) {
      return {
        ...state,
        sowingTasks: action.payload,
      };
    },
    saveTaskItems(state, action) {
      return {
        ...state,
        taskItems: action.payload,
      };
    },
    onView(state, action) {
      return {
        ...state,
        entity: action.entity,
        entityUuid: action.entityUuid,
        taskNumber: action.taskNumber
      }
    },
    onShowPage(state, action) {
      return {
        ...state,
        showPage: action.showPage,
        entityUuid: action.entityUuid,
        taskNumber: action.taskNumber,
        importType: action.importType,
        importData: action.importData,
        cacheData: action.cacheData,
        adjData: action.adjData
      }
    },
    savePickTask(state, action) {
      return {
        ...state,
        wavePickTaskData: action.payload,
      };
    }
  }
}
